import * as _ from 'lodash';
import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import COLORS from '../../../../theme/colors';

const LINE_HEIGHT = 12;
const LINE_GAP = LINE_HEIGHT / 2;
//  Helper for determining the size and position of each of the "lines" of code.
const getLineDimentions = (lineNumber = 0) => ({
  width: '90%',
  height: LINE_HEIGHT,
  x: '9%',
  y: ((LINE_HEIGHT + LINE_GAP) * lineNumber) + LINE_GAP,
  rx: 2,
  ry: 2,
});

/**
 * FileViewerFileContentsLoading displays the react-content-loader
 * which mocks the Codemirror view, to indicate that it is loading.
 */
const FileViewerFileContentsLoading: VoidFunctionComponent = () => (
  <ContentLoader width="100%" height="300px" style={{ border: `1px solid ${COLORS.fossaGray10}`, borderRadius: '4px' }}>
    {/* Sidebar line */}
    <rect x="0" y="0" width="7.5%" height="100%" />
    {/* Each line of the "file" */}
    {[..._.range(0, 16)].map(lineNumber => (
      <rect key={lineNumber} {...getLineDimentions(lineNumber)} />
    ))}
  </ContentLoader>
);

export default FileViewerFileContentsLoading;
